module.exports = __webpack_public_path__ + "static/media/UnionLogo.55062012.svg";